import callflowQueryKeys from 'app/hooks/queries/callflow/callflowQueryKeys';
import scheduleQueryKeys from 'app/hooks/queries/schedule/scheduleQueryKeys';
import { useMutation, useQueryClient } from 'react-query';
import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';
import { CallflowUpdatePartialDoc } from 'types/callflow';

export const useUpdateSchedulePartial = () => {
  const authState = useAuthSelector();
  const queryClient = useQueryClient();
  return useMutation(
    (callflowPartialDoc: CallflowUpdatePartialDoc) =>
      sdk.callflow.mutate.updatePartial(
        {
          data: callflowPartialDoc,
          // other values such as "accept_charges" could go here
        },
        {
          authToken: authState?.auth_token,
        },
      ),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(callflowQueryKeys.all);
        await queryClient.invalidateQueries(scheduleQueryKeys.all);
      },
    },
  );
};
